import React, { useEffect, useCallback, useState } from "react";
import { debounce } from "lodash";
import { IconButton, InputAdornment, FormControl, Input } from "@mui/material/";
import { Close, Search } from "@mui/icons-material";
import { strings } from "../i18n";

const func = () => {};

type Props = {
    defaultValue: string,
    delay: number,
    onBlur: Function,
    onFocus: Function,
    onValueChange: Function,
    placeholder: string
};

/**
 * SearchBox Component
 */
export default ({
    defaultValue = "",
    delay = 800,
    onBlur = func,
    onFocus = func,
    onValueChange,
    placeholder = strings("search")
}: Props) => {
    const [value, setValue] = useState("");

    const debounceValueChange = useCallback(
        debounce((value: string) => {
            onValueChange && onValueChange(value);
        }, delay),
        [delay, onValueChange]
    );

    const onChange = useCallback(
        (event: Event) => {
            const next = event.target.value;
            setValue(next);
            debounceValueChange(next);
        },
        [debounceValueChange]
    );

    const onDelete = useCallback(() => {
        setValue("");
        debounceValueChange("");
    }, [debounceValueChange]);

    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);

    return (
        <FormControl fullWidth variant="standard">
            <Input
                id="standard-adornment-amount"
                startAdornment={
                    <InputAdornment position="start">
                        <Search />
                    </InputAdornment>
                }
                endAdornment={
                    <InputAdornment position="end">
                        {value && (
                            <IconButton onClick={onDelete} size="small">
                                <Close />
                            </IconButton>
                        )}
                    </InputAdornment>
                }
                onBlur={onBlur}
                onChange={onChange}
                onFocus={onFocus}
                placeholder={placeholder}
                value={value}
            />
        </FormControl>
    );
};
